<template>
  <div v-if="!loading" class="crf-wrapper" @click="openConfirm">
    <!-- <div :style="{'color': 'red', 'text-align': 'center', 'width': '100%', 'position': 'fixed', 'top': '100px', 'z-index': '1000'}">
      <span @click.stop="download">下载</span>
      <div @click.stop>
        <van-uploader v-model="upload.list"/>
      </div>
    </div> -->
    <entrance v-if="detailData.checkPageResult && detailData.checkPageResult.pageIndex !== 3" :detail-data="detailData.checkPageResult" @refresh="getDetail" />
    <result-success v-else-if="status === 4" :coupon="couponText" @iknow="iknow" @click.stop />
    <result-fail v-else-if="status === 3" :timeout="true" @close="onLeave" @click.stop />
    <result-fail v-else-if="status === 5" :reason="failedReason" @close="onLeave" @click.stop />
    <result-fail v-else-if="status === 6" @close="onLeave" @click.stop />

    <template v-else>
      <div v-show="headerShow" class="crf-content" @click.stop>
        <div class="crf-header" @click.stop="headerClose">
          <img v-if="detailData.showTopUrl" :src="detailData?.showTopUrl" class="header-img">
          <!-- <img
            :class="['close-btn', {'no-headerimg': !detailData?.showTopUrl}, {'close-btn2': isDetail}]"
            :src="isDetail ? '../../assets/crf/close.png' : 
              (detailData?.showTopUrl ? '../../assets/crf/close2.svg' : '../../assets/crf/close3.svg')"
            @click.stop="openConfirm" /> -->
          <img
            v-if="isDetail"
            :class="['close-btn', 'close-btn2', {'no-headerimg': !detailData?.showTopUrl}]"
            src="../../assets/crf/close.png"
            @click.stop="openConfirm" />
          <img
            v-else-if="detailData?.showTopUrl"
            :class="['close-btn']"
            src="../../assets/crf/close2.svg"
            @click.stop="openConfirm" />
          <img
            v-else
            :class="['close-btn', 'no-headerimg']"
            src="../../assets/crf/close3.svg"
            @click.stop="openConfirm" />
        </div>
        <div
          :class="['crf-edit-content', {'no-headerimg': !detailData?.showTopUrl}]"
          :style="{
            'background': `url('${detailData.showBackgroundUrl}') no-repeat #fff`,
            'background-size': '100%',
            'padding-bottom': safePadding + 'px'}">
          <div class="title-wrapper padlr">
            <div class="title">{{ detailData.title }}</div>
            <div v-if="detailData.instruction" class="activity-desc" @click="openDesc">活动说明</div>
          </div>
          <div class="sub-title padlr">{{ detailData.subTitle }}</div>
          <div v-if="status === 1" class="steps-wrapper padlr">
            <div class="step-top">
              <div v-if="quesActive !== 0" class="pre-btn" @click="onPre">
                <i class="prev-icon"></i>上一题
              </div>
              <div class="steps-count">
                <div class="step-active">{{ quesActive + 1 }}</div>/{{ questionLen }}
              </div>
            </div>
            <div class="step-line-content">
              <div class="step-line-active" :style="{'width': stepWidth}"></div>
            </div>
          </div>
          <div :class="['question-list padlr', { 'is-detail': isDetail }]">
            <div class="question-item" v-for="(ques, key) in detailData.questionList" :key="key">
              <component
                v-show="isDetail || quesActive === key"
                v-model="quesActive"
                :is="getComp(ques)"
                :index="key"
                :question-data="ques"
                :is-last="isLast"
                :is-detail="isDetail"
                :risk-pic="riskPicSwitch"
                @uploading="val => uploading = val"/>
            </div>
            <div v-if="isDetail" class="thanks-wrapper">- 感谢您的宝贵反馈 -</div>
          </div>
          <template v-if="status === 1">
            <btn v-model="quesActive" :all-question="detailData.questionList" />
            <div v-if="isLast" class="submit-wrapper">
              <van-button
                :class="['submit-btn', { 'disabled': submitDisabled }, { 'is-waiting': isWaiting }]"
                :loading="isWaiting" loading-text="努力提交中..."
                @click="submit">
                提交问卷
              </van-button>
            </div>
          </template>
        </div>
      </div>
    </template>

    <van-dialog v-model:show="confirmVisible" class="confirm-dialog" :show-confirm-button="false" @click.stop>
      <div class="confirm-title">是否确认退出问卷</div>
      <div class="confirm-desc">退出后，您填写的问卷内容将无法保存</div>
      <div class="confirm-btns">
        <div class="confirm-btn leave-btn" @click.stop="dialogLeave">确认退出</div>
        <div :class="['confirm-btn', 'continue-btn', {'is-cotti': isCotti}]" @click.stop="onContinue">继续问卷</div>
      </div>
    </van-dialog>

    <div v-if="descVisible" class="desc-dialog" :style="{'padding-bottom': (safePadding - 36) + 'px'}" :show-confirm-button="false" @click.stop>
      <i class="close-btn" @click.stop="closeDesc"></i>
      <div class="desc-title">活动说明</div>
      <div class="desc-content" v-html="detailData.instruction"></div>
      <div class="iknow-btn" @click.stop="closeDesc">我知道了</div>
    </div>

    <div v-if="isWaiting" class="mask" @click.stop></div>

  </div>
  <div v-else>
    <loading-page />
  </div>
</template>

<script>
import Entrance from './entrance.vue'
import LoadingPage from './components/loadingPage.vue'
import Radio from './components/question/radio.vue';
import Mutil from './components/question/mutil.vue';
import Fill from './components/question/fill.vue';
import Btn from './components/btn.vue';
import _ from 'lodash';
import { Toast } from 'vant';

import ResultSuccess from './success.vue';
import ResultFail from './fail.vue';
import { questionnaireDetailApi, submitQuestionnaireApi } from "@/api/crf/index";
import { jsBridgeCloseDialogPromise, jsBridgeDownloadPromise, jsBridgeIknowPromise, jsBridgeCheckLocationPromise } from '@/utils/bridgeRegisterHandle';
import { getDisabled, highVersion, skipToDefault, getTip } from './helper';
// import { isCottiApp } from '@/utils/index';
// import { mockData } from './mock';

export default {
  name: 'Crf',
  components:{
    Radio,
    Mutil,
    Fill,
    Btn,
    ResultSuccess,
    ResultFail,
    Entrance,
    LoadingPage
  },
  computed: {
    questionLen() {
      return this.detailData.questionList?.length || 0;
    },
    isLast() {
      if (this.quesActive === this.questionLen - 1) {
        this.$sensors.track('survey_submit_view', {
          memberQuestionnaireId: this.$route.query.memberQuestionnaireId
        });
      }
      return this.quesActive === this.questionLen - 1
    },
    hasAnswer() {
      let flag = false;
      this.detailData.questionList.forEach(ques => {
        if (ques.questionType === 3) {
          ques.memberAnswerList?.forEach(item => {
            if (item?.memberOptionContent || item?.memberAnswerPicList?.length) {
              flag = true;
            }
          });
        } else if (ques.memberAnswerList.filter(item => item.memberOptionSelected === 1)?.length > 0) {
          flag = true;
        }
      });
      return flag;
    },
    submitDisabled() {
      const lastQues = _.last(this.detailData.questionList);
      let flag = getDisabled(lastQues, true, this.hasAnswer);
      if (lastQues.questionType === 3 && lastQues.answerType === 2) { // 简答题 选填
        return !this.hasAnswer;
      }
      return flag;
    },
    stepWidth() {
      return ((this.quesActive + 1) / this.questionLen) * 100 + '%';
    },
    isDetail() {
      return this.status === 2;
    },
    safePadding() {
      return 16 + (+(this.$route.query.safeBottom || 0))
    },
  },
  data() {
    return {
      queryParams: window.location.href.split('?')?.[1]?.split('&'),
      uploading: false,
      isWaiting: false,
      detailData: {
        title: '',
        subTitle: '',
        instruction: '',
        showTopUrl: '',
        showBackgroundUrl: '',
        questionnaireSubmitStatus: 1, // 1待提交  2已提交  3已失效
        questionList: null,
      },
      riskPicSwitch: false,
      triggerType: 0, // 触发方式0自动1手动 默认0

      confirmVisible: false,
      descVisible: false,
      headerShow: true,
      quesActive: 0,
      loading: true,
      couponText: '',
      status: 0, // 1待提交  2已提交  3已失效 4提交成功 5提交失败  6不存在
      failedReason: '',
      isCotti: navigator.userAgent?.includes('cottiCoffee'),
    };
  },
  watch: {
    uploading(val) {
      if (this.isWaiting && !val) {
        this.isWaiting = false;
        this.submit();
      }
    },
    quesActive(val, oldVal) {
      if (val > 0) {
        this.$sensors.track('survey_previous_view', {
          memberQuestionnaireId: this.$route.query.memberQuestionnaireId
        });
      }
      if (this.detailData?.questionList?.[val].answerType === 2) {
        this.$sensors.track('survey_skip_view', {
          num: val + 1,
          memberQuestionnaireId: this.$route.query.memberQuestionnaireId
        })
      }
      this.clearDiryData(oldVal);
      this.scrollPageToTop();
    }
  },
  mounted() {
    setTimeout(() => {
      this.getDetail();
    }, 200);
  },
  methods: {
    getPoi(params) {
      const hrefPoi = this.queryParams?.find(item => item.includes('poi'))?.split('=')?.[1]?.split(',');
      console.log('hrefPoi', hrefPoi?.[0], hrefPoi?.[1])
      return {
        longitude: params?.longitude || hrefPoi?.[0],
        latitude: params?.latitude || hrefPoi?.[1],
      }
    },
    async getDetail(params) {
      let positionAuthorize = 0 
      if (highVersion()) {
        positionAuthorize = await jsBridgeCheckLocationPromise(); // 是否位置授权 0否1是
      }
      const poi = this.getPoi(params);
      if (this.triggerType == 0) {
        // 触发方式0自动1手动 默认0
        this.triggerType = params?.triggerType || (this.queryParams?.find(item => item.includes('automation'))?.split('=')?.[1] === 'false' ? 1 : 0)
      }
      // this.detailData = mockData;
      // this.status = this.detailData.questionnaireSubmitStatus;

      this.$sensors.track('survey_view', {
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });

      questionnaireDetailApi({
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId,
        scanCode: params?.scancode?.result,
        latitude: poi?.latitude,
        longitude: poi?.longitude,
        triggerType: this.triggerType,
        positionAuthorize: positionAuthorize?.status || 0, 
      }).then(res => {
        if (res.busCode === '10001') { // 问卷不存在
          this.status = 6;
        } else {
          if (res.busCode == 0) {
            this.loading = false;
            Toast(res.busMessage);
            return false;
          }
          this.detailData = res.data;
          this.riskPicSwitch = this.detailData.riskPicSwitch;
          this.status = this.detailData.questionnaireSubmitStatus;
          this.detailData.instruction = this.detailData.instruction?.replaceAll('\\n', '<br>')
          this.detailData.questionList = this.detailData.questionList?.map(item => {
            item.questionJoin = 0;
            return item;
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    clearDiryData(oldVal) {
      const dirtyList = this.detailData.questionList[oldVal]?.memberAnswerList?.filter(item => item.memberOptionSelected !== 1);
      dirtyList?.map(item => {
        item?.childAnswerList?.map(child => {
          this.$set(child, 'memberOptionContent', '');
          this.$set(child, 'memberAnswerPicList', null);
        });
      });
    },
    scrollPageToTop() {
      this.$nextTick(() => {
        const questionId = this.detailData.questionList[this.quesActive]?.questionId;
        const quesRef = document.getElementById('scrollArea' + questionId);
        if (quesRef) {
          quesRef.scrollTop = 0;
        }
      });
    },
    headerClose() {
      if (!this.isDetail && !this.detailData.showTopUrl) {
        this.openConfirm();
      } else if (!this.detailData.showTopUrl) {
        this.onLeave();
      }
    },
    // download() {
    //   jsBridgeDownloadPromise('https://cdn-product-prod.yummy.tech/cotti_h5/images/arc.svg')
    // },
    getComp(question) {
      switch(question.questionType) { // 1单选, 2多选, 3问答
        case 1:
          return Radio;
        case 2:
          return Mutil;
        case 3:
          return Fill;
        default:
          return Radio;
      }
    },
    getAnswerList(item) {
      return {
        answerId: item.answerId,
        memberOptionContent: item.memberOptionContent,
        memberOptionSelected: item.memberOptionSelected,
        memberOptionPicList: item.memberAnswerPicList?.map(pic => pic.picUrl),
        childAnswerList: item.childAnswerList?.map(child => {
          return this.getAnswerList(child) || null
        })
      }
    },
    submit() {
      this.$sensors.track('survey_submit_click', {
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
      if (this.submitDisabled) {
        const lastQues = _.last(this.detailData.questionList);
        Toast(getTip(lastQues));
        if (this.submitDisabled && lastQues.questionType !== 3) {
          skipToDefault.value = {
            change: true,
            parent: lastQues,
            detail: this.submitDisabled
          };
        }
        return;
      }
      if (this.uploading) {
        this.isWaiting = true;
        return;
      }
      this.isWaiting = false;
      const quesData = [];
      _.forEach(this.detailData.questionList, item => {
        quesData.push({
          questionId: item.questionId,
          questionJoin: getDisabled(item) ? 0 : 1,
          memberAnswerSubmitList: item.memberAnswerList?.map(answer => {
            return this.getAnswerList(answer)
          })
        });
      });
      submitQuestionnaireApi({
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId,
        memberQuestionSubmitList: quesData
      }).then(res => {
        // 1待提交  2已提交  3已失效 4提交成功 5提交失败  6不存在
        if (res.busCode === '10001') { // 问卷不存在
          this.status = 6;
        } else if (res.busCode === '0') {
          Toast(res.busMessage);
        } else if (res.data?.isSuccess) { // 提交成功
          this.status = 4;
          this.couponText = res.data?.prizeText;
        } else { 
          this.status = 5;
          this.failedReason = res.data?.failMessage;
        }
      }).catch(err => {
        Toast('提交失败');
      });
    },
    openConfirm() {
      if (this.detailData.checkPageResult?.pageIndex !== 3) {
        this.onLeave();
      } else if (this.hasAnswer && this.status === 1) {
        this.confirmVisible = true;
        this.$sensors.track('survey_close_confirm_view', {
          count: this.detailData.questionList.filter(item => item.questionJoin === 1)?.length || 0,
          memberQuestionnaireId: this.$route.query.memberQuestionnaireId
        });
      } else {
        this.onLeave();
      }
    },
    dialogLeave() {
      this.$sensors.track('survey_close_confirm_click', {
        count: this.detailData.questionList.filter(item => item.questionJoin === 1)?.length || 0,
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
      this.onLeave();
    },
    onLeave() {
      jsBridgeCloseDialogPromise();
      this.$sensors.track('survey_close', {
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
    },
    onPre() {
      this.quesActive--;
      this.$sensors.track('survey_previous_click', {
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
    },
    iknow() {
      jsBridgeIknowPromise();
      this.onLeave();
    },
    onContinue() {
      this.$sensors.track('survey_close_confirm_click', {
        count: this.detailData.questionList.filter(item => item.questionJoin === 1)?.length || 0,
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
      this.confirmVisible = false;
    },
    openDesc() {
      this.descVisible = true
      this.headerShow = false
    },
    closeDesc() {
      this.descVisible = false
      this.headerShow = true
    },
  }
}
</script>

<style lang="scss" scoped>
.crf-wrapper{
  position: relative;
  background: transparent;
  font-family: PingFangSC, PingFang SC;
  height: 100vh;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    background: transparent;
    width: 100%;
    height: 100vh;
    z-index: 100;
  }
  :deep(.van-dialog__cancel) {
    background: #fff;
    border-radius: 22px;
    border: 1px solid #DDDDDD;
  }
  .crf-content {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .crf-header {
    position: relative;
    clear: both;
    overflow: hidden;
    min-height: 80px;
    display: flex;
    align-items: flex-end;
    .header-img {
      width: 100%;
    }
    .close-btn {
      position: absolute;
      bottom: 1px;
      right: 32px;
      width: 136px;
      height: 40px;
      &.no-headerimg {
        bottom: 24px;
      }
    }
    .close-btn2 {
      position: absolute;
      bottom: 1px;
      right: 32px;
      width: 48px;
      height: 48px;
      &.no-headerimg {
        bottom: 24px;
      }
    }
  }
  .crf-edit-content {
    padding: 36px 0;
    box-sizing: border-box;
    overflow: auto;
    .padlr {
      padding-left: 32px;
      padding-right: 32px;
    }
    &.no-headerimg {
      border-radius: 24px 24px 0 0 ;
    }
  }
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: 500;
      font-size: 32px;
      color: #3A3B3C;
    }
    .activity-desc {
      width: 112px;
      height: 40px;
      line-height: 40px;
      background: #F8F8F8;
      border-radius: 20px;
      text-align: center;
      font-weight: 400;
      font-size: 20px;
      margin-left: 16px;
      flex: none;
      color: #555;
    }
  }
  .sub-title {
    font-weight: 400;
    font-size: 24px;
    color: #89898A;
    margin-top: 24px;
    .ques-title {
      font-weight: 500;
      font-size: 32px;
      color: #3A3B3C;
      line-height: 40px;
      display: flex;
      align-items: center;
      .type-tag {
        border-radius: 22px;
        border: 2px solid rgba(255,88,62,0.3);
        font-weight: 500;
        font-size: 22px;
        color: #FF583E;
        display: inline-block;
        padding: 1px 12px;
        margin-right: 8px;
      }
      .optional {
        font-weight: 400;
        font-size: 28px;
        color: #ACACAC;
        display: inline-block;
      }
      &.is-detail {
        color: #89898A;
        font-weight: 400;
        margin-top: 40px;
      }
    }
  }
  .steps-wrapper {
    margin-top: 28px;
    margin-bottom: 16px;
    line-height: 44px;
    .step-top {
      display: flex;
      align-items: center;
      .steps-count {
        font-weight: 500;
        font-size: 24px;
        color: #BABABA;
        .step-active {
          display: inline-block;
          color: #FF583E;
          font-size: 28px;
        }
      }
    }
    .pre-btn {
      width: 120px;
      height: 40px;
      line-height: 70px;
      border-radius: 22px;
      border: 2px solid rgba(255,88,62,0.3);
      font-weight: 500;
      font-size: 22px;
      color: #FF583E;
      display: flex;
      align-items: center;
      padding-left: 12px;
      margin-right: 16px;
      box-sizing: border-box;
      .prev-icon {
        width: 24px;
        height: 24px;
        background: url(../../assets/crf/prev.svg);
        background-size: 100% 100%;
        margin-right: 4px;
      }
    }
    .step-line-content {
      margin-top: 8px;
      height: 8px;
      background: #FFEDDB;
      border-radius: 4px;
    }
    .step-line-active {
      height: 8px;
      background: #FF583E;
      border-radius: 4px;
    }
  }
  .question-list {
    &.is-detail {
      // margin-top: 30px;
      overflow: auto;
      max-height: 68vh;
      .question-item {
        max-height: unset;
      }
    }
  }
  .thanks-wrapper {
    font-weight: 400;
    font-size: 24px;
    color: #BABABA;
    text-align: center;
    margin-top: 26px;
  }
  .submit-wrapper {
    border-top: 1px solid #F0F0F0;
  }
  .submit-btn {
    display: block;
    width: 326px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(153deg, #FF7573 0%, #FF4545 100%);
    border-radius: 48px;
    margin: 16px auto 0;
    color: #fff;
    text-align: center;
    font-weight: 500;
    border: none;
    &.disabled {
      background: #D4D4D4;
    }
    &.is-waiting {
      opacity: 0.4;
    }
  }
  .desc-dialog {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 32px 26px;
    border-radius: 24px 24px 0 0;
    background: #fff;
    box-sizing: border-box;
    .close-btn {
      position: absolute;
      top: 24px;
      right: 20px;
      width: 48px;
      height: 48px;
      background: url(../../assets/crf/close.png);
      background-size: 100% 100%;
    }
    .desc-title {
      font-weight: 500;
      font-size: 32px;
      color: #3A3B3C;
      line-height: 44px;
      text-align: center;
    }
    .desc-content {
      margin-top: 42px;
      font-weight: 400;
      font-size: 26px;
      color: #3A3B3C;
      line-height: 40px;
      max-height: 68vh;
      overflow: auto;
    }
    .iknow-btn {
      height: 88px;
      line-height: 88px;
      background: linear-gradient(153deg, #FF7673 0%, #FF3D3D 100%);
      border-radius: 48px;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      text-align: center;
      margin: 24px 0;
    }
  }
  .confirm-dialog {
    width: 590px;
    padding: 48px 32px 32px 32px;
    box-sizing: border-box;
    text-align: center;
    .confirm-title {
      font-weight: 500;
      font-size: 32px;
      color: #3A3B3C;
    }
    .confirm-desc {
      margin-top: 40px;
      font-weight: 400;
      font-size: 28px;
      color: #3A3B3C;
    }
    .confirm-btns {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: medium;
    }
    .confirm-btn {
      width: 244px;
      height: 86px;
      line-height: 86px;
      border-radius: 44px;
    }
    .leave-btn {
      background: #f1f1f1;
      border: 1px solid #f1f1f1;
      color: #000;
    }
    .continue-btn {
      background: #97D700;
      color: #fff;
      &.is-cotti {
        background: #A52337;
      }
    }
  }
}
</style>

<style land="scss">
html, body {
  background: transparent;
}
img {
  user-select: none;
}
</style>
